import redBanner from "./banner/redBanner.jpg";
import blueBanner from "./banner/blueBanner.jpg";
import react, { Component } from "react";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";

import "./bannerPhoto.css";

import React from "react";

const BannerPhoto = ({ props }) => {
  const state = {
    appName: props.appName,
    courseName: `${props.courseName} Course`,
    coursePrice: `at just ₹ ${props.coursePrice}/-`,

    color: props.color,
    educatorPhoto: props.educatorPhoto,
  };

  const download = () => {
    // domtoimage
    //   .toBlob(document.getElementById("banner"), {
    //     quality: 1,
    //   })
    //   .then((blob) => {
    //     saveAs(blob, "poster.jpg");
    //   });
    var container = document.getElementById("banner"); //specific element on page
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    // var container = document.getElementById("htmltoimage");; // full page
    html2canvas(container, { allowTaint: true }).then(function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");
      link.target = "_blank";
      link.click();
    });
  };

  console.log(state.color);

  return (
    <div className="bannerContainer">
      <div
        className="banner"
        id="banner"
        style={
          state.color == "blue"
            ? { backgroundImage: `url(${blueBanner})` }
            : state.color == "red"
            ? { backgroundImage: `url(${redBanner})` }
            : state.color == ""
            ? { backgroundImage: `url(${redBanner})` }
            : ""
        }
      >
        <span id="appName-banner">{state.appName}</span>
        <div className="detailsDisplay-banner">
          <div className="left-banner">
            <span id="launching-banner">Launching</span>
            <span id="courseName-banner">
              {state.courseName}
              <br />
            </span>
            <span id="coursePrice-banner">{state.coursePrice}</span>
            <span id="buyNowCta-banner">Buy Now</span>
          </div>
          <div className="right-banner">
            <img src={state.educatorPhoto} id="educatorPhoto-banner" />
            <span id="hashtag-banner">#PadhaiNahiRukegi</span>
          </div>
        </div>
      </div>
      <button id="bannerCta-banner" onClick={download}>
        Click To Download
      </button>
    </div>
  );
};

export default BannerPhoto;
